var popupFormV2Module =
    (
        function (popupFormV2Module) {
            popupFormV2Module.OpenPopupForm = function (triggerId) {
                console.log('OpenPopupForm');
                let customPopupId = `.custom-popup-${triggerId}`;
                let bgOpacityId = `.bg-opacity-${triggerId}`;
                let customAlertId = `.custom-alert-${triggerId}`;
                let closeMessageBtnId = `.close-msg-button-${triggerId}`;
                let closeMessageCloseAreaId = `.close-msg-close-area-${triggerId}`;
                $(customPopupId).show();
                $(closeMessageBtnId).show();
                if ($(customPopupId).css('display') == 'block') {
                    $(bgOpacityId).addClass('opacity-active');
                    $(`${customPopupId} ${customAlertId}`).removeAttr('hidden');
                    $(closeMessageCloseAreaId).addClass('popover-form-v2-close-area');
                }
                $(closeMessageBtnId).on('click', function (e) {
                    $(bgOpacityId).removeClass('opacity-active').addClass('opacity-remove');
                    $(customPopupId).hide();
                    $(closeMessageBtnId).hide();
                    $(closeMessageCloseAreaId).removeClass('popover-form-v2-close-area');
                });
                $(closeMessageCloseAreaId).on('click', function (e) {
                    $(bgOpacityId).removeClass('opacity-active').addClass('opacity-remove');
                    $(customPopupId).hide();
                    $(closeMessageBtnId).hide();
                    $(closeMessageCloseAreaId).removeClass('popover-form-v2-close-area');
                });
            }

            return popupFormV2Module;
        }
    )(popupFormV2Module || {});
